import { addDoc, setDoc, collection, doc } from "firebase/firestore";
import { getLocalStorageItem } from "../../../../controllers/localStorage/getLocalStorage";
import { db } from "../../../../firebase";
import HelperForMetaData from "../../../../helpers/HelperForMetaData";
// import { db } from "../../firebase";
// import HelperForMetaData from "../../helpers/HelperForMetaData";
// import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const SaveDealController = async (id, dealData, transactionData, visitData) => {
  console.log("start ", transactionData, visitData, dealData);
  try {
    /** Extracting transactions */
    const transactions = transactionData;

    /** Create Deals */
    dealData = { ...dealData, bid: getLocalStorageItem("bid") };
    const dealsDocument = await doc(db, "deals", id);
    await setDoc(dealsDocument, dealData);
    console.log("Deal added");
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default SaveDealController;
